export default __webpack_public_path__ + "images/95acba6a6ed55d4a91857cc99fe69622.svg";